import { Injectable } from "@angular/core";
import { fuseConfig } from "app/fuse-config";
import { NetworkService } from "app/main/services/network-service.service";
import { Observable, of } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { tap } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class AuthenticationService {
    public isAuthenticated = false;
    private token: string | null = null;

    constructor(
        private networkService: NetworkService,
        private http: HttpClient
    ) {}

    oauth(): Observable<any> {
        if (this.token) {
            return of({ access_token: this.token });
        }

        //console.trace();
        
        // PARA DEV
        //    audience: fuseConfig.URL.split("com")[0] + "com",
        // PARA PRD
        //    audience: "https://app.deepssportrecovery.com",
        const body = {
            client_id: "cVKybWiewn05l1U41IU1yUPgtRXAcUxEnMh2XUpvrI",
            client_secret: "5KDQhq7VBPJUlMQngFHl5VWui7JDI7PRjE7qoXiM",
            audience: "https://app.deepssportrecovery.com",
            grant_type: "client_credentials",
        };

        return this.networkService.post("oauth/token", body).pipe(
            tap((res) => {
                this.token = res.access_token;
                this.isAuthenticated = true;
            })
        );
    }

    clearToken(): void {
        this.token = null;
        this.isAuthenticated = false;
    }

    login(body): Observable<any> {
        return this.networkService.post("oauth/authenticate", body);
    }

    getProfile(): Observable<any> {
        return this.networkService.get("profile");
    }

    getServiceStaffByLocation(
        location: string,
        token: string
    ): Observable<any> {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const headers = new HttpHeaders({
            "app-authorization": `Bearer ${token}`,
        });

        return this.networkService.get(
            `location/${location}/service_staff?timezone=${timezone}`,
            token
        );
    }
}
